// play icon 

export default function PlayIcon({idx, onClick, className = ""}) {
    return (
        <svg key={idx} onClick={onClick} className={className} style={{cursor: "pointer"}} xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none">
            <rect x="0.444336" y="0.253174" width="48" height="48" rx="24" fill="#0069FD"/>
            <path d="M31.6197 22.5212C32.953 23.291 32.953 25.2155 31.6197 25.9853L22.3567 31.3333C21.0233 32.1031 19.3567 31.1408 19.3567 29.6012L19.3567 18.9052C19.3567 17.3656 21.0233 16.4034 22.3567 17.1732L31.6197 22.5212Z" fill="white"/>
        </svg>
    );
}